import { cn } from "@/lib/utils";

/**
 * Grain loading indicator — three ink dots on the paper backdrop, used by the
 * full-screen chat and app-boot loaders in place of the old off-palette blue
 * spinner. Styling (tokened colors + reduced-motion-gated bounce) lives in the
 * `.grain-loader` rule in `index.css`; this component is the shared markup so
 * the `role="status"` / `aria-label` / three-`<span>` shape stays identical at
 * every call site.
 */
export function GrainLoader({
  className,
  "aria-label": ariaLabel = "Loading",
}: {
  className?: string;
  "aria-label"?: string;
}) {
  return (
    <div className={cn("grain-loader", className)} role="status" aria-label={ariaLabel}>
      <span />
      <span />
      <span />
    </div>
  );
}
